import { ReactNode } from "react"

type BaseSectionType = {
    noBackground?: boolean
    hfull?: boolean
    classProps?: string
    children: ReactNode
    responsive?: string
}

export default function BaseSection(props: BaseSectionType) {
    return (
        <section
            className={`${props.classProps} ${props.responsive ?? "flex flex-col overflow-x-hidden overflow-y-scroll"} rounded-default w-full ${props.hfull ? "h-full" : "grow"}  ${
                props.noBackground ?? "bg-white shadow-lg p-4 "
            }`}>
            {props.children}
        </section>
    )
}
